import { useMemo } from 'react'

import { useReactiveVar } from '@apollo/client'

import { BookingInvoiceBatchFilterInput, InvoiceType } from 'generated/graphql'
import { invoiceBatchFiltersFormVar } from 'graphql/reactiveVariables'
import { dateTimeZoneFormat } from 'helpers'

import { BatchFilterCriteria } from '../InvoiceBatchFilterCriteriaForm/InvoiceBatchFilterForm'

export const useInvoiceBatchFilter = (): BookingInvoiceBatchFilterInput => {
  const batchFilters = useReactiveVar(invoiceBatchFiltersFormVar)

  return useMemo(() => {
    const filters: BookingInvoiceBatchFilterInput[] = [
      { invoiceType: { eq: InvoiceType.Purchase } },
    ]

    if (!batchFilters) {
      return { and: filters }
    }

    if (batchFilters.batchSearch) {
      const batchId = parseInt(batchFilters.batchSearch, 10)
      if (!isNaN(batchId)) {
        filters.push({ id: { eq: batchId } })
      }
    }

    if (batchFilters.dueInStartDate || batchFilters.dueInEndDate) {
      const startDate = batchFilters.dueInStartDate
        ? dateTimeZoneFormat(batchFilters.dueInStartDate, 'start')
        : null
      const endDate = batchFilters.dueInEndDate
        ? dateTimeZoneFormat(batchFilters.dueInEndDate, 'end')
        : null

      const dateFilter: any = {}
      if (startDate) dateFilter.gte = startDate
      if (endDate) dateFilter.lte = endDate

      switch (batchFilters.dateSelection) {
        case BatchFilterCriteria.PaymentDate:
          filters.push({ paymentDate: dateFilter })
          break
        case BatchFilterCriteria.InvoiceDate:
          filters.push({ date: dateFilter })
          break
      }
    }

    if (batchFilters.xeroPurchaseCodes?.length > 0) {
      filters.push({
        batchLines: {
          some: {
            accountCode: {
              in: batchFilters.xeroPurchaseCodes.map((x) => x.label),
            },
          },
        },
      })
    }

    if (batchFilters?.batchType) {
      filters.push({ batchType: { eq: batchFilters.batchType } })
    }

    return { and: filters }
  }, [batchFilters])
}
